import React from 'react';
import styled from 'styled-components';
import variables from '../../variables';

const BtnGroup = styled.div`
  display: flex;
  gap: 6px;
  justify-content: center;
`;

const BtnDownload = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 6px;
  border: 1px solid ${variables.primary};
  color: ${variables.primary};
  text-decoration: none;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${variables.primary};
    color: #fff;
    text-decoration: none;

    svg {
      fill: #fff;
    }
  }
`;

const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={{ flexShrink: 0 }}
  >
    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
  </svg>
);

function DownloadQrField({ data }) {
  const pngSrc = data?.src?.download_png;
  const svgSrc = data?.src?.download_svg;

  return (
    <BtnGroup>
      {pngSrc ? (
        <BtnDownload
          href={pngSrc}
          download
          target="_blank"
          rel="noopener noreferrer"
          title="Scarica PNG"
        >
          <DownloadIcon />
          PNG
        </BtnDownload>
      ) : (
        <span>-</span>
      )}
      {svgSrc ? (
        <BtnDownload
          href={svgSrc}
          download
          target="_blank"
          rel="noopener noreferrer"
          title="Scarica SVG"
        >
          <DownloadIcon />
          SVG
        </BtnDownload>
      ) : (
        <span>-</span>
      )}
    </BtnGroup>
  );
}

export default DownloadQrField;
